import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as Sentry from '@sentry/angular';
// import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { NgxEchartsModule } from 'ngx-echarts';
import { AdminGeneralEffects } from './admin/store/general/admin.effects';
import { AnalyticsModule } from './analytics/analytics.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AuthEffects } from './auth/store/auth.effects';
import { AuthInterceptor } from './auth/utility/auth.interceptor';
import { AuthService } from './auth/utility/auth.service';
import { CoreModule } from './core/core.module';
import { IdleWarningDialogModule } from './core/idle-watch/idle-warning-dialog/idle-warning-dialog.module';
import { GlobalService } from './core/services/global.service';
import { InsightsModule } from './insights/insights.module';
import { MATERIAL_PROVIDERS } from './material.providers';
import { MonitoringModule } from './monitoring/monitoring.module';
import { AdsModule } from './shared/ads/ads.module';
import { SubscriptionEffects } from './shared/subscription/store/subscription.effects';
import { VehicleEffects } from './shared/vehicle/store/vehicle.effects';
import { AppEffects } from './store/app.effects';
import { metaReducers, reducers } from './store/app.reducers';
import { TA_LIB_PROVIDERS } from './ta-lib.providers';
import { getDateLocale, TranslocoRootModule } from './transloco-root.module';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeRu from '@angular/common/locales/ru';
import localeCn from '@angular/common/locales/zh';
import { InNavigationPlaceholderComponent } from "./core/in-navigation-placeholder/in-navigation-placeholder.component";

// Register locales
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeRu);
registerLocaleData(localeCn);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StoreModule.forRoot(reducers, {
        metaReducers,
    }),
    EffectsModule.forRoot([
        AppEffects,
        AuthEffects,
        AdminGeneralEffects,
        VehicleEffects,
        SubscriptionEffects,
    ]),
    BrowserAnimationsModule,
    NgxEchartsModule.forRoot({
        echarts: () => import('echarts'),
    }),
    CoreModule,
    TranslocoRootModule,
    MatNativeDateModule,
    MatDialogModule,
    // TODO: These modules should ideally be lazy-loaded
    InsightsModule,
    AnalyticsModule,
    MonitoringModule,
    IdleWarningDialogModule,
    AdsModule,
    InNavigationPlaceholderComponent
],
  providers: [
    AuthService,
    GlobalService,
    // { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // {
    //   provide: RECAPTCHA_SETTINGS,
    //   useValue: { siteKey: '6LdCO0ApAAAAAGlgTlAVMm22JZHQ3qc89068aLH9' } as RecaptchaSettings,
    // },
    ...MATERIAL_PROVIDERS,
    ...TA_LIB_PROVIDERS,
    { provide: MAT_DATE_LOCALE, useValue: getDateLocale() },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
